import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { EffectIndex } from '@/define/define'

export type LightEffectListType = { [name: LightEffectModeType]: EffectIndex }

/**
 * Jingtai V2
 */
export const LIGHT_EFFECT_LIST_JTV2: LightEffectListType = {
  [LightEffectMode.Static]: 0,
  [LightEffectMode.Wave_jingtaiV2]: 1,
  [LightEffectMode.RainbowWheel]: 7,
  [LightEffectMode.Prosperity_jtv2]: 3,
  [LightEffectMode.SpinningWindmill_jtv2]: 4,
  [LightEffectMode.BreathingRhythm_jtv2]: 8,
  [LightEffectMode.RainbowDream_jtv2]: 6,
  [LightEffectMode.SevenColorWaterfall_jtv2]: 2,
  [LightEffectMode.Scanning]: 9,
  [LightEffectMode.RainbowCluster_jtv2]: 5,
  [LightEffectMode.RainbowBeacon_jtv2]: 13,
  [LightEffectMode.HorizontalCycle_jtv2]: 10,
  [LightEffectMode.CandyRaindrop_jtv2]: 15,
  [LightEffectMode.SineWave_jtv2]: 11,
  [LightEffectMode.Starry_jtv2]: 14,
  [LightEffectMode.WaveMotion]: 12,

  [LightEffectMode.ClickHighlight_jtv2]: 16,
  [LightEffectMode.ShadowChase_jtv2]: 17,
  [LightEffectMode.InstantFlash_jtv2]: 18,
  [LightEffectMode.KeyRipple_jtv2]: 19,
  [LightEffectMode.Custom_light]: 21,
  [LightEffectMode.MusicStarry_jtv2]: 0,
  [LightEffectMode.MusicCrossFlow_jtv2]: 1,
  [LightEffectMode.MusicCloudFlow_jtv2]: 2,
  [LightEffectMode.MusicValley_jtv2]: 3,
}

/**
 * 晶泰V1
 */
export const LIGHT_EFFECT_LIST_PRO: LightEffectListType = {
  [LightEffectMode.Static_pro]: 0,
  [LightEffectMode.SaturatedStyle_pro]: 1,
  [LightEffectMode.RainbowWheel_1]: 7,
  [LightEffectMode.Prosperity_1]: 3,
  [LightEffectMode.SpinningWindmill_1]: 4,
  [LightEffectMode.BreathingRhythm_pro]: 8,
  [LightEffectMode.RainbowDream_2]: 6,
  [LightEffectMode.SevenColorWaterfall_1]: 2,
  [LightEffectMode.Scanning_1]: 5,
  [LightEffectMode.RainbowCluster_pro]: 9,
  [LightEffectMode.RainbowBeacon_pro]: 13,
  [LightEffectMode.HorizontalCycle_pro]: 10,
  [LightEffectMode.CandyRaindrop_pro]: 15,
  [LightEffectMode.SineWave_1]: 11,
  [LightEffectMode.Starry_2]: 14,
  [LightEffectMode.WaveMotion_1]: 12,
  [LightEffectMode.PixelFlow_1]: 16,
  [LightEffectMode.ClickHighlight_pro]: 17,
  [LightEffectMode.ShadowChase_pro]: 18,
  [LightEffectMode.InstantFlash_pro]: 19,
  [LightEffectMode.KeyRipple_pro]: 20,
  [LightEffectMode.Custom_light]: 100,
  [LightEffectMode.Starry_Brightness]: 0,
  [LightEffectMode.CrossFlow_Brightness]: 1,
  [LightEffectMode.CloudFlow_Brightness]: 2,
  [LightEffectMode.MusicValley_Brightness]: 3,
}

/**
 * 晶泰V1  v1.4.0 专用版本
 */
export const LIGHT_EFFECT_LIST_PRO_V140: LightEffectListType = {
  ...LIGHT_EFFECT_LIST_PRO,
  [LightEffectMode.Scanning_1]: 5,
  [LightEffectMode.RainbowBeacon_pro]: 10,
  [LightEffectMode.HorizontalCycle_pro]: 11,
  [LightEffectMode.SineWave_1]: 13,
  [LightEffectMode.RainWalk_1]: 17,
  [LightEffectMode.StarryNight_1]: 18,
  [LightEffectMode.ClickHighlight_pro]: 19,
  [LightEffectMode.Collision_2]: 20,
}

/**
 * 晶泰V1  v1.3.0 专用版本
 */
export const LIGHT_EFFECT_LIST_PRO_V130: LightEffectListType = {
  [LightEffectMode.Wave_2]: 0,
  [LightEffectMode.Prosperity_1]: 1,
  [LightEffectMode.PixelFlow_1]: 2,
  [LightEffectMode.SineWave_1]: 3,
  [LightEffectMode.RainbowDream_2]: 4,
  [LightEffectMode.RainWalk_1]: 5,
  [LightEffectMode.SpinningWindmill_1]: 6,
  [LightEffectMode.StarryNight_1]: 7,
  [LightEffectMode.RainbowWheel_1]: 8,
  [LightEffectMode.SevenColorWaterfall_1]: 9,
  [LightEffectMode.WaveMotion_1]: 10,
  [LightEffectMode.Starry_2]: 11,
  [LightEffectMode.Scanning_1]: 12,
  [LightEffectMode.Collision_2]: 13,
  [LightEffectMode.Custom_light]: 100,
  [LightEffectMode.Starry_Brightness]: 0,
  [LightEffectMode.CrossFlow_Brightness]: 1,
  [LightEffectMode.CloudFlow_Brightness]: 2,
  [LightEffectMode.MusicValley_Brightness]: 3,
}

/**
 * 容圆
 */
export const LIGHT_EFFECT_LIST_ND68: LightEffectListType = {
  [LightEffectMode.Static]: 0x01,
  [LightEffectMode.Breathing_nd68]: 0x02,
  [LightEffectMode.Neon]: 0x03,
  [LightEffectMode.Wave_nd68]: 0x04,
  [LightEffectMode.KeyRipple]: 0x05,
  [LightEffectMode.StarryNight]: 0x06,
  [LightEffectMode.HorseRace_nd68]: 0x07,
  [LightEffectMode.ClickHighlight_nd68]: 0x08,
  [LightEffectMode.Prosperity_nd68]: 0x09,
  [LightEffectMode.SineWave]: 0x0a,
  [LightEffectMode.BreathingRhythm_nd68]: 0x0b,
  [LightEffectMode.HueWave_nd68]: 0x0c,
  [LightEffectMode.InstantFlash]: 0x0e,
  [LightEffectMode.SpinningWindmill_nd68]: 0x0f,
  [LightEffectMode.RainCurtain]: 0x10,
  [LightEffectMode.RainWalk]: 0x11,
  [LightEffectMode.PixelFlow_nd68]: 0x12,
  [LightEffectMode.SnowTrace]: 0x13,
  [LightEffectMode.HorizontalCycle_nd68]: 0x17,
  [LightEffectMode.Custom_light]: 100,
}

/**
 * NA87, ND75 等
 */
export const LIGHT_EFFECT_LIST_IROKN_ST: LightEffectListType = {
  [LightEffectMode.Static_1]: 0,
  [LightEffectMode.Breathing]: 1,
  [LightEffectMode.Wave]: 2,
  [LightEffectMode.Neon_1]: 3,
  [LightEffectMode.Radar]: 4,
  [LightEffectMode.ClickHighlight]: 6,
  [LightEffectMode.Laser]: 7,
  [LightEffectMode.KeyRipple]: 8,
  [LightEffectMode.Starry_1]: 9,
  [LightEffectMode.Starry]: 0,
  [LightEffectMode.CrossFlow]: 1,
  [LightEffectMode.CloudFlow]: 2,
  [LightEffectMode.MusicValley]: 3,
  [LightEffectMode.CrossCursor]: 11,
  [LightEffectMode.KeystrokeRate]: 12,
  [LightEffectMode.RippleAutoPlay]: 14,
  [LightEffectMode.SixLineRace]: 15,
  [LightEffectMode.Fireworks]: 16,
  [LightEffectMode.Custom]: 100,
}

/**
 *  AL87, FE75, TP87 等
 */
export const LIGHT_EFFECT_LIST_IROKN_ST_V1: LightEffectListType = {
  [LightEffectMode.Static]: 1,
  [LightEffectMode.Breathing_1]: 2,
  [LightEffectMode.RainbowDream]: 3,
  [LightEffectMode.Neon]: 3,
  [LightEffectMode.RainCurtain]: 5,
  [LightEffectMode.RainWalk]: 5,
  [LightEffectMode.RainbowWheel]: 6,
  [LightEffectMode.StarryNight]: 8,
  [LightEffectMode.FlowingStream]: 10,
  [LightEffectMode.WaveMotion]: 11,
  [LightEffectMode.SineWave]: 13,
  [LightEffectMode.Scanning]: 14,
  [LightEffectMode.SpinningWindmill]: 15,
  [LightEffectMode.SevenColorWaterfall]: 16,
  [LightEffectMode.RainbowWaterfall]: 16,
  [LightEffectMode.Prosperity]: 17,
  [LightEffectMode.SpinningStorm]: 18,
  [LightEffectMode.Collision]: 19,
  [LightEffectMode.InstantFlash]: 4,
  [LightEffectMode.KeyRipple]: 7,
  [LightEffectMode.ShadowChase]: 12,
  [LightEffectMode.SnowTrace]: 9,
  [LightEffectMode.Starry]: 0,
  [LightEffectMode.CrossFlow]: 1,
  [LightEffectMode.CloudFlow]: 2,
  [LightEffectMode.MusicValley]: 3,
  [LightEffectMode.Custom]: 100,
}

/**
 * MG63/RA68 火柴人
 */
export const LIGHT_EFFECT_LIST_HuoChaiRen: LightEffectListType = {
  [LightEffectMode.Close]: 0,
  [LightEffectMode.Wave_mg63]: 1,
  [LightEffectMode.RainbowWheel]: 2,
  [LightEffectMode.SpinningWindmill_nd68]: 3,
  [LightEffectMode.HueBreathing_mg63]: 4,
  [LightEffectMode.BreathingRhythm_mg63]: 5,
  [LightEffectMode.Static]: 6,
  [LightEffectMode.RainbowDream_mg63]: 10,
  [LightEffectMode.StarryNight]: 11,
  [LightEffectMode.CandyRaindrop_huochairen]: 12,
  [LightEffectMode.SineWave_mg63]: 13,
  [LightEffectMode.SpiralCycle_mg63]: 14,
  [LightEffectMode.RainCurtain]: 15,
  [LightEffectMode.Scanning_mg63]: 16,
  [LightEffectMode.HorseRace]: 17,
  [LightEffectMode.Prosperity_mg63]: 18,
  [LightEffectMode.Custom_light]: 100,
  [LightEffectMode.KeyRipple_mg63]: 7,
  [LightEffectMode.ClickHighlight_jtv2]: 8,
  [LightEffectMode.InstantFlash_mg63]: 9,

  [LightEffectMode.Starry_Brightness]: 0,
  [LightEffectMode.CrossFlow_Brightness]: 1,
  [LightEffectMode.CloudFlow_Brightness]: 2,
  [LightEffectMode.MusicValley_Brightness]: 3,
}

/**
 * MG63/RA68 火柴人
 */
export const LIGHT_EFFECT_LIST_MG63: LightEffectListType = {
  ...LIGHT_EFFECT_LIST_HuoChaiRen,
  [LightEffectMode.SideClose]: 0x0,
  [LightEffectMode.SideWave_RA68_1]: 0x01,
  [LightEffectMode.SideNeon]: 0x02,
  [LightEffectMode.SideBreathing_RA68_1]: 0x03,
  [LightEffectMode.SideHorseRace]: 0x04,
  [LightEffectMode.SideFleeting_RG68_1]: 0x05,
  [LightEffectMode.SideStatic_RA68_1]: 0x06,
}
